export default function () {

  const doc     = document.documentElement, // html
    trigger       = document.querySelector('.menu-trigger'),
    menu          = document.querySelector('.main-menu-wrapper .menu'),
    nav           = menu.querySelector('nav');

  trigger.addEventListener('click', function () {
    doc.classList.toggle('menu-is-open');
    let isOpen = doc.classList.contains('menu-is-open');
    menu.setAttribute('aria-expanded', isOpen);

    // console.log(menu.dataset.setHeight); // eslint-disable-line
    if(menu.dataset.setHeight !== undefined) {
      menu.style.height =  isOpen ? nav.clientHeight + 'px' : 0;
    }

  }, false);

  menu.setAttribute('aria-expanded', menu.clientHeight > 0);
}
